module.exports = __webpack_public_path__ + "static/media/music.7b23bf9b.svg";